module.exports = __webpack_public_path__ + "static/media/failed.06143dc0.png";